import styled, { css } from 'styled-components';

export const FreecodePlayerBackground = styled.div`
  ${({ isPopOut }) =>
    isPopOut &&
    css`
      position: fixed; !important;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.15);
      z-index: 1000;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
    `}

  ${({ isPartOfFreecode }) =>
    isPartOfFreecode &&
    css`
      backdrop-filter: blur(0.8px);
    `}
`;

export const FreecodePlayerContainer = styled.div`
  ${({ isPopOut }) =>
    isPopOut &&
    css`
      border-radius: 5px 5px 0px 0px;
      box-shadow: 0px 15px 30px 5px rgba(50, 50, 50, 0.5);
      background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};
      border: 1px solid ${({ theme }) => theme.modal.border};
    `}

  ${({ isPartOfFreecode }) =>
    isPartOfFreecode &&
    css`
      border: 0px;
      background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};
    `}
`;

export const CanvasContainer = styled.div`
  width: 100%;
  height: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};
`;

export const CanvasHolder = styled.div`
  overflow: hidden;
  ${({ width, height }) => css`
    width: ${width}px;
    height: ${height}px;
  `}
`;

export const PixiCanvas = styled.canvas`
  vertical-align: bottom;
`;
